// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactDom from "react-dom";
function callbackDomRef(prim) {
  return prim;
}
function domRef(prim) {
  return prim;
}
var Ref = {
  callbackDomRef: callbackDomRef,
  domRef: domRef
};
function unmountComponentAtNode(prim) {
  ReactDom.unmountComponentAtNode(prim);
}
function render(prim0, prim1) {
  ReactDom.render(prim0, prim1);
}
export { Ref, unmountComponentAtNode, render };
/* react-dom Not a pure module */